// Linear segment class
// Linear segment is defined by two points defined by two points
// It is the shortest path between two points
import { Cartesian2, Cartesian3 } from "cesium";
import { CurveType } from "./interface";
export class LinearSegment {
    type = CurveType.LINEAR;
    _startPoint;
    _endPoint;
    constructor(start, end) {
        this._startPoint = start;
        this._endPoint = end;
    }
    dispose() {
        this._startPoint = undefined;
        this._endPoint = undefined;
    }
    get points() {
        return [this._startPoint, this._endPoint];
    }
    get length() {
        return Cartesian3.distance(this._startPoint, this._endPoint);
    }
    get length_2D() {
        return Cartesian2.distance(this._startPoint, this._endPoint);
    }
    getCurveData() {
        return {
            type: CurveType.LINEAR,
            start: this._startPoint,
            end: this._endPoint,
        };
    }
    static fromData(data) {
        return new LinearSegment(data.start, data.end);
    }
}
//# sourceMappingURL=linear-segment.js.map